// @flow
import { APICore } from './apiCore';
import config from '../../config';
import { buildQueryParams } from './search-shipments-kpis-request';

const api = new APICore();

const BASE_URL = config.TRANSIT_TIMES_ANALYTICS_URL;

const makeApiCall = (endpoint: string, query: Query | string): Promise<any> => {
    if (typeof query === 'string') {
        return api.get(`${BASE_URL}${endpoint}?${query}`, {}, {});
    }
    const queryParams = buildQueryParams(query);
    return api.get(`${BASE_URL}${endpoint}`, queryParams, {});
};

function getAverageDomesticQuotedDays(query): any {
    const endpoint = '/avg_domestic_quoted_days';
    return makeApiCall(endpoint, query);
}

function getAverageDomesticActualDays(query): any {
    const endpoint = '/avg_domestic_actual_days';
    return makeApiCall(endpoint, query);
}

function getTransitTimesByServiceLevel(query): any {
    const endpoint = '/transit_times_by_service_level';
    return makeApiCall(endpoint, query);
}

function getTransitTimesByTimeframe(query): any {
    const endpoint = '/transit_times_by_timeframe';
    return makeApiCall(endpoint, query);
}

function getTransitTimesSummary(query): any {
    const endpoint = '/transit_times_summary';
    return makeApiCall(endpoint, query);
}

export {
    getAverageDomesticQuotedDays,
    getAverageDomesticActualDays,
    getTransitTimesByServiceLevel,
    getTransitTimesByTimeframe,
    getTransitTimesSummary,
};
